import debounce = require("lodash.debounce")
import { moment, Moment } from '../../utils/moment'
import { features } from "../../features"

// Shared generic date formatting logic
const formatDates = (
  event: { Start?: Date, End?: Date },
  formatSingle: (date: Moment) => string,
  rangeSeparator: string,
  timeSeparator: string
) => {
  const { Start, End } = event
  const start = moment(Start).milliseconds(0)
  const midnight = moment(Start).endOf('day')
  const end = moment(End)

  // If the dates span multiple dates
  // return two formated dates, including time when relevant.
  if (midnight.isBetween(start, end)) {
    return `${formatSingle(start)}${rangeSeparator}${formatSingle(end)}`
  }

  // If we have proper time for start and end
  // return one formated date with both times
  if (hasTime(start) && hasTime(end)) {
    return `${formatSingle(start)}${timeSeparator}${end.format('HH:mm')}`
  }

  // Else, return whatever Start will yield
  return formatSingle(start)
}

export const formatDatesShort = (event: { Start?: Date, End?: Date }) =>
  formatDates(event, formatSingleDateShort, ' – ', ' - ')

export const formatDatesLong = (event: { Start?: Date, End?: Date }) =>
  formatDates(event, formatSingleDateLong, ' t/m ', ' tot ')

const formatSingleDateShort = (date: Moment) => date.format(
  hasTime(date)
    ? 'dd D-M-YYYY HH:mm'
    : 'dd D-M-YYYY'
)

const formatSingleDateLong = (date: Moment) => date.format(
  hasTime(date)
    ? 'dddd DD MMMM, H:mm'
    : 'dddd DD MMMM'
)

const hasTime = (date: Moment) => !date.isSame(moment(date).startOf('day'))

export const asPrice = (cents: number) =>
  (cents / 100)
    .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
    .replace(',00', ',-')

export const Monday = 1

export const tomorrow = (plus: number = 0) => {
  const now = new Date()
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1 + plus)
}
export const nextWeek = (plus: number = 0) => getNextWeekDay(new Date(), Monday, plus)
export const nextMonth = (plus: number = 0) => {
  const now = new Date()
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1 + plus, 1, 0, 0, 0)
  return nextMonth
}

export const getNextWeekDay = (startDate, dayOfWeek, plus: number = 0) => {
  const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)
  const dayOffset = dayOfWeek > start.getDay()
    ? dayOfWeek - start.getDay()
    : dayOfWeek - start.getDay() + 7

  start.setDate(start.getDate() + dayOffset + (plus * 7))

  return start
}

export const pushEventAction = () => {
  const { pushDataLayer } = features()
  return (action: string, label?: string) => pushDataLayer({ category: 'events', action, label })
}

export const debouncedPush = debounce((push: (action: string, label?: string) => void, action: string, label?: string) => push(action, label), 1500)